import styled from 'styled-components';
import { device } from '../../constants';

export const BlogWrapper = styled.div`
  :is([data-theme='dark'] &) {
    background-color: ${({ theme }) => theme.colors["neutral-08"]};
  }
`;

export const BlogTitle = styled.h1`
  position: relative;

  font-size: 24px;
  font-weight: 500;
  line-height: 32px;
  color: ${({ theme }) => theme.colors["neutral-07"]};

  margin: 0;
  margin-top: 24px;
  padding-top: 16px;
  text-align: left;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    transform: translate(0, -50%);
    width: 32px;
    height: 4px;
    background: ${({ theme }) => theme.colors["branding-01"]};
    border-radius: 100px;
  }

  @media ${device.tablet} {
    font-size: 32px;
    line-height: 120%;
    margin-top: 64px;
    padding-top: 24px;

    &::before {
      left: 0;
      transform: none;
      width: 48px;
    }
  }

  :is([data-theme='dark'] &) {
    color: ${({ theme }) => theme.colors["neutral-01"]};

    &::before {
      background: ${({ theme }) => theme.colors["branding-01"]};
    }
  }
`;

export const LastUpdated = styled.div`
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: ${({ theme }) => theme.colors["neutral-04"]};
  margin-top: 8px;
  margin-bottom: 24px;
  text-align: left;

  @media ${device.tablet} {
    font-size: 16px;
    margin-bottom: 32px;
  }

  :is([data-theme='dark'] &) {
    color: ${({ theme }) => theme.colors["neutral-03"]};
  }
`;

export const ContentText = styled.div`
  * {
    color: ${({ theme }) => theme.colors["neutral-05"]};

    :is([data-theme='dark'] &) {
      color: ${({ theme }) => theme.colors["neutral-01"]};
    }
  }

  & p {
    margin: 0;
    font-size: 18px;
    line-height: 32px;
    font-weight: 400;
    text-align: left;
    color: ${({ theme }) => theme.colors["neutral-05"]};

    :is([data-theme='dark'] &) {
      color: ${({ theme }) => theme.colors["neutral-01"]};
    }

    & + p {
      margin-top: 16px;

      @media ${device.tablet} {
        margin-top: 24px;
      }
    }
  }

  & strong {
    font-weight: 600;
    color: ${({ theme }) => theme.colors["neutral-05"]};

    :is([data-theme='dark'] &) {
      color: ${({ theme }) => theme.colors["neutral-01"]};
    }
  }

  & li {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 130%;
    text-align: left;
    color: ${({ theme }) => theme.colors["neutral-05"]};

    :is([data-theme='dark'] &) {
      color: ${({ theme }) => theme.colors["neutral-01"]};
    }

    & + li {
      margin-top: 1.5rem;
    }
  }

  & > :is(h2, h3) {
    font-weight: 700;
    font-size: 20px;
    line-height: 32px;
    color: ${({ theme }) => theme.colors["neutral-07"]};
    margin: 16px 0;

    :is([data-theme='dark'] &) {
      color: ${({ theme }) => theme.colors["neutral-01"]};
    }
  }

  & > h2 {
    margin-top: 40px;
  }

  & > h3 {
    font-size: 18px;
  }

  @media ${device.tablet} {
    & > :is(h2, h3) {
      font-size: 26px;
      line-height: 48px;
      margin: 24px 0;
    }

    & > h2 {
      margin-top: 48px;
    }

    & > h3 {
      font-size: 22px;
    }

    & li, & p {
      font-size: 22px;
      line-height: 40px;
      text-align: justify;
    }
  }

  table {
    width: 100%;
    border-collapse: collapse;
    margin: 16px 0 24px;

    th, td {
      border: 1px solid ${({ theme }) => theme.colors["neutral-05"]};
      padding: 12px;
      text-align: left;
      font-size: 14px;
      line-height: 150%;

      :is([data-theme='dark'] &) {
        border-color: ${({ theme }) => theme.colors["neutral-05"]};
      }

      @media ${device.tablet} {
        font-size: 16px;
        padding: 16px;
      }
    }

    th {
      font-weight: 600;
      background-color: rgba(78, 75, 152, 0.15);

      :is([data-theme='dark'] &) {
        background-color: rgba(78, 75, 152, 0.25);
      }
    }
  }

  .contact-info {
    margin-top: 16px;

    a {
      color: ${({ theme }) => theme.colors["branding-01"]};
      text-decoration: underline;

      :is([data-theme='dark'] &) {
        color: ${({ theme }) => theme.colors["vivid-01"]};
      }
    }
  }
`;
